const BANK_LOGOS = [[/absa/i, "/pay/absa.svg"], [/co-?op/i, "/pay/coop.png", "rounded-md bg-[#0b6b3a] px-1.5 py-1"]];
const GATEWAY_LOGOS = { mpesa: "/pay/mpesa.svg", pesapal: "/pay/pesapal.png" };
const GATEWAY_NAMES = { pesapal: "Pesapal", dpo: "DPO Pay", cybersource: "CyberSource", mpgs: "Mastercard Gateway" };

export const methodTitle = (m, bank) => (m === "mpesa" ? "M-Pesa" : bank ? `Card – secured by ${bank}` : `Card via ${GATEWAY_NAMES[m]}`);

const Badge = ({ text }) => (
  <span className="inline-flex h-7 items-center rounded-md bg-brand px-2 text-[11px] font-semibold uppercase tracking-wide text-white">{text}</span>
);

export const MethodLogo = ({ m, bank }) => {
  const hit = bank && BANK_LOGOS.find(([re]) => re.test(bank));
  const src = hit?.[1] || (!bank && GATEWAY_LOGOS[m]);
  if (src) return <img src={src} alt={bank || GATEWAY_NAMES[m] || "M-Pesa"} className={`h-7 max-w-[110px] object-contain ${hit?.[2] || ""}`} />;
  return <Badge text={bank || GATEWAY_NAMES[m]} />;
};

export const CardBrands = () => (
  <span className="inline-flex items-center gap-1.5">
    <img src="/pay/visa.svg" alt="Visa" className="h-3.5" />
    <img src="/pay/mastercard.svg" alt="Mastercard" className="h-5" />
  </span>
);
